// app/(public)/signup/page.tsx  (or wherever your SignUpPage lives)
'use client';

import Loading from '@/components/Loading';
import { useGoogleSignUp } from '@/hooks/useGoogleSignUp';
import { Stack } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
export default function GoogleSignIn({
  context
}: {
  context: 'signin' | 'signup';
}) {
  const router = useRouter();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // this mutation will call your Google signup endpoint
  const googleSignup = useGoogleSignUp();
  return <>
      {isLoggingIn && <Loading message="Logging you in..." />}
      <Stack spacing={2} alignItems="center" mb={2} data-sentry-element="Stack" data-sentry-source-file="GoogleSignIn.tsx">
        <GoogleLogin context={context} useOneTap onSuccess={res => {
        setIsLoggingIn(true);
        googleSignup.mutate({
          credential: res.credential!
        }, {
          onSuccess: () => {
            router.push('/exams');
          },
          onError: error => {
            console.error('Google sign-in error:', error);
            setIsLoggingIn(false);
          }
        });
      }} onError={(...err) => {
        console.error('err', err);
        /* handle UI error */
      }} data-sentry-element="GoogleLogin" data-sentry-source-file="GoogleSignIn.tsx" />
      </Stack>
    </>;
}